"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebhookDefinitionDisabledOrigin = void 0;
var WebhookDefinitionDisabledOrigin;
(function (WebhookDefinitionDisabledOrigin) {
    WebhookDefinitionDisabledOrigin["AutomaticallyBlocked"] = "WEBHOOK_DEFINITION_DISABLED_AUTOMATICALLY_BLOCKED";
    WebhookDefinitionDisabledOrigin["DisabledOnDashboard"] = "WEBHOOK_DEFINITION_DISABLED_ON_DASHBOARD";
    WebhookDefinitionDisabledOrigin["DisabledByBringg"] = "WEBHOOK_DEFINITION_DISABLED_BY_BRINGG";
})(WebhookDefinitionDisabledOrigin || (exports.WebhookDefinitionDisabledOrigin = WebhookDefinitionDisabledOrigin = {}));
//# sourceMappingURL=webhook_definition.js.map